import { Auth } from "aws-amplify";

export default async function () {
    await Auth.signOut();
}